<div class="create-property-container">
    <mat-card class="create-property-card">
        <mat-card-header>
            <div class="header-container">
                <img src="assets/images/logo_full_900.png" alt="Logo" class="main-logo" /><br/>
                <h2>Publish Your Listing</h2>
            </div>
        </mat-card-header>
        <mat-card-content>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1.8em;">
                <div>
                    <mat-card class="horizinns-terms-card">
                        <mat-card-header>
                            <mat-card-title>
                                Horizinns Listing Terms
                            </mat-card-title>
                            <mat-card-subtitle>Simple. Transparent. Host-Friendly.</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <section class="section">
                                <h3>
                                    <mat-icon>paid</mat-icon>
                                    Simple, Transparent Pricing
                                </h3>
                                <ul>
                                    <li><strong>$300 flat annual subscription fee</strong> per property.</li>
                                    <li><strong>Zero booking fees</strong> — You keep <strong>100%</strong> of your rental income. No commissions, no hidden charges per reservation.</li>
                                </ul>
                                </section>

                                <section class="section">
                                <h3>
                                    <mat-icon>settings</mat-icon>
                                    Stay in Full Control
                                </h3>
                                <ul>
                                    <li>Update your property listings, availability calendars, pricing, and availability in real time — whenever you want.</li>
                                    <li>Communicate directly with renters through our secure messaging system — no middleman interfering.</li>
                                    <li>Set your own house rules, minimum stay requirements, check-in/check-out times, security deposits, guest requirements, and any other policies that suit your property.</li>
                                </ul>
                                </section>

                                <!-- <section class="section">
                                <h3>
                                    <mat-icon>devices</mat-icon>
                                    Flexible Multi-Platform Approach
                                </h3>
                                <ul>
                                    <li>List your property on Horizinns while keeping it active on Airbnb, Vrbo, Booking.com, or any other platforms you use.</li>
                                    <li>No exclusivity required — Horizinns is designed to complement your existing channels.</li>
                                    <li>Ideal for individual homeowners, small hosts, or professional property managers looking to diversify bookings and maximize direct revenue.</li>
                                </ul>
                                </section> -->

                                <section class="section">
                                <h3>
                                    <mat-icon>autorenew</mat-icon>
                                    Subscription & Cancellation Policy
                                </h3>
                                <ul>
                                    <li>Your subscription is for a <strong>12-month term</strong> and will <strong>auto-renew</strong> annually at the then-current rate unless you cancel.</li>
                                    <li>You may cancel your subscription <strong>at any time</strong> through your account dashboard or by contacting support.</li>
                                    <li>Cancellation takes effect at the end of the current paid term (no early termination).</li>
                                    <li><strong>No prorated refunds</strong> — If you cancel mid-term, you retain full access until the end of your current subscription period.</li>
                                    <li>We reserve the right to modify subscription fees or terms with at least 30 days' notice (via email or account notification). Continued use after changes constitutes acceptance.</li>
                                </ul>
                                </section>

                                <p class="footer-note">
                                By listing a property on Horizinns, you agree to these Listing Terms, our general Terms of Service, and Privacy Policy. Horizinns provides a platform to connect hosts with potential renters; we do not guarantee bookings, act as a travel agent, or manage payments between parties (unless otherwise specified in future features).
                                </p>
                        </mat-card-content>
                    </mat-card>
                </div>
                <div>
                    <mat-card class="horizinns-pricing-card">
                        <mat-card-header>
                            <mat-card-title>
                            <mat-icon class="title-icon">calendar_today</mat-icon>
                            Activate Your Listing for a Full Year
                            </mat-card-title>
                            <mat-card-subtitle>One simple payment — no surprises</mat-card-subtitle>
                        </mat-card-header>

                        <mat-card-content>
                            <div class="pricing-highlight">
                                <div class="price">
                                    <span class="currency">$</span>300
                                </div>
                                <div class="details">
                                    <strong>per property • per year</strong>
                                    <p class="validity">
                                    Active listing from <strong>{{ today | date:'MMMM d, yyyy' }}</strong><br>
                                    through <strong>{{ oneYearLater | date:'MMMM d, yyyy' }}</strong>
                                    </p>
                                </div>
                            </div>

                            <ul class="benefits">
                            <li><mat-icon>check_circle</mat-icon> Unlimited bookings — keep 100% of your income</li>
                            <li><mat-icon>check_circle</mat-icon> Real-time updates & direct guest messaging</li>
                            <li><mat-icon>check_circle</mat-icon> List alongside Airbnb, Vrbo, and others</li>
                            <li><mat-icon>check_circle</mat-icon> Auto-renews only if you choose to continue</li>
                            </ul>

                            <p class="note">
                            One-time payment today. Cancel anytime before renewal — no prorated refunds.
                            </p>
                        </mat-card-content>

                        <mat-card-actions align="end">
                            <button mat-raised-button color="primary" class="continue-btn" (click)="onContinue()">
                            Continue to Activate Listing
                            <mat-icon>arrow_forward</mat-icon>
                            </button>
                        </mat-card-actions>
                    </mat-card>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
